import { TCounterpartySelectorMode } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/types.ts';

export const COUNTERPARTY_SELECTOR_DEFAULT_MODE: TCounterpartySelectorMode =
  TCounterpartySelectorMode.Client;
export const COUNTERPARTY_CACHE_DATE_FORMAT = 'DD.MM.YYYY HH:mm';
export const counterpartyCodeValidLengths = [8, 10] as const;
export const counterpartySelectorPaperStyle = { width: '100%', maxWidth: 600 } as const;
export const counterpartySearchInputProps = {
  inputMode: 'numeric',
  maxLength: 10,
} as const;

export const counterpartySelectorText = {
  title: 'Вибір контрагента',
  searchPlaceholder: 'Введіть ЄДРПОУ/РНОКПП контрагента',
  searchAriaLabel: 'Введіть ЄДРПОУ/РНОКПП контрагента',
  submitButton: 'Знайти',
  submitButtonLoading: 'Пошук...',
  noContragentsFound: 'Контрагентів не знайдено',
  accessDenied: 'Доступу немає',
  selectionDialogTitle: 'Оберіть контрагента',
  edrpouLabel: 'ЄДРПОУ',
  cachedSearchDropdownDatePrefix: 'Вхід',
};

export const COUNTERPARTY_SEARCH_CACHE_PREFIX = 'covenants:last-selected-edrpou:v1';
export const UNKNOWN_USER_CACHE_KEY = 'unknown-user';
export const identitySourceKeys = ['username', 'login', 'email', 'id', 'userId', 'uid', 'phone'];
